import { SVGProps } from 'react';
import SVG from '.';
import { SVGIconFilterPriceEyeFifty } from './SVGIconFilterPriceEyeFifty';
import { SVGIconFilterPriceEyeHundred } from './SVGIconFilterPriceEyeHundred';
import { SVGIconFilterPriceEyeHundredFifty } from './SVGIconFilterPriceEyeHundredFifty';

export default Object.assign(
  ({ children, ...rest }: SVGProps<any>) => {
    return <SVG.Icon.Filter {...rest}>{children}</SVG.Icon.Filter>;
  },
  {
    Fifty: SVGIconFilterPriceEyeFifty,
    Hundred: SVGIconFilterPriceEyeHundred,
    HundredFifty: SVGIconFilterPriceEyeHundredFifty,
  },
);
